import { format } from 'date-fns';
import { create } from 'zustand';
import { DATE_FORMAT } from '../../../shared/constants';
export const defaultActiveFilters = {
    dateRangeFrom: '',
    dateRangeTo: '',
    customerId: null,
    officeId: null,
    event: '',
    template: null,
    isSent: null,
    recipient: '',
    sender: '',
};
const useActiveFiltersStore = create()((set) => ({
    activeFilters: defaultActiveFilters,
    setActiveFilters: (filters) => set((state) => ({
        activeFilters: {
            ...filters,
            dateRangeFrom: format(new Date(filters.dateRangeFrom), DATE_FORMAT),
            dateRangeTo: format(new Date(filters.dateRangeTo), DATE_FORMAT),
        },
    })),
    resetActiveFilters: () => set(() => ({
        activeFilters: {
            ...defaultActiveFilters,
        },
    })),
}));
export default useActiveFiltersStore;
